export enum RegistrationStatusEnum {
    NoAnswer = 0,
    Attending = 1,
    Representative = 2,
    IndependentRepresentative = 3
}
